import React, { useState } from 'react'
import VisibilitySensor from 'react-visibility-sensor'
import IndustryColumn from './IndustryColumn'
import NarrativeCards from './NarrativeCards'
import { getIndustryTimes, getYearPercent } from '../utils/dataParsers'
import { isMobile } from 'react-device-detect'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../css/IndustryMatrix.scss'

const getTimeMarkers = () => {
  let yearArray = []
  for (var i = 1870; i <= 2020; i = i + 30) {
    yearArray.push(i)
  }
  return yearArray.reverse()
}

const IndustryMatrix = ({ narratives, industries, times, headline }) => {
  const [hoverSelector, setHoverSelector] = useState('')
  const [matrixVisible, setMatrixVisible] = useState(false)

  let leftIndustries = {};
  let rightIndustries = {};
  const centerIndustries = Math.ceil(Object.keys(industries).length / 2);

  Object.keys(industries).forEach((item, index) => {
    if (index < centerIndustries) {
      leftIndustries[item] = industries[item];
    } else {
      rightIndustries[item] = industries[item];
    }
  });

  const IndustryHoverHandler = (key, isEnter) => {
    setHoverSelector(isEnter ? key : '')
  }
  const matrixVisiblityChange = isVisible => {
    if (isVisible) {
      setMatrixVisible(true)
    }
  }
  // maybe use filter to create sorted industry-specific objects
  return (
    <Container>
      <div className='pageLayout landing'>
        <Row>
          <Col sm={12} md={7} lg={12}>
            <h2 className='secondary-headline'>{headline.dt_headline}</h2>
          </Col>
        </Row>
        <NarrativeCards narratives={narratives} industryHoverHandler={IndustryHoverHandler} />
        {isMobile
          ? <h2 className='secondary-headline'>{headline.mobile_headline}</h2>
          : ''}
        <div className={`matrix-container ${window.innerWidth > 1024 ? 'wrapper' : ''}`}>
          <VisibilitySensor onChange={matrixVisiblityChange} partialVisibility>
            <div className={`industry_matrix ${matrixVisible ? 'isVisible' : ''}`}>
              <style>
                {`
                .time_point:not(.${hoverSelector}) {
                  opacity: 0.3;
                }
                `}
              </style>

              {
                window.innerWidth < 1025 ?
                  <Row>
                    <Col sm={12} md={6}>
                      {
                        Object.keys(leftIndustries).map((industryKey, index, arr) =>
                          <IndustryColumn
                            industry={industries[industryKey]}
                            industryKey={industryKey}
                            key={industryKey}
                            count={arr.length}
                            index={index}
                            times={getIndustryTimes(industryKey, times)}
                            industryHoverHandler={IndustryHoverHandler}
                          />
                        )
                      }
                    </Col>
                    <Col sm={12} md={6}>
                      {
                        Object.keys(rightIndustries).map((industryKey, index, arr) =>
                          <IndustryColumn
                            industry={industries[industryKey]}
                            industryKey={industryKey}
                            key={industryKey}
                            count={arr.length}
                            index={index}
                            times={getIndustryTimes(industryKey, times)}
                            industryHoverHandler={IndustryHoverHandler}
                          />
                        )
                      }
                    </Col>
                  </Row>
                :
                  Object.keys(industries).map((industryKey, index, arr) =>
                    <IndustryColumn
                      industry={industries[industryKey]}
                      industryKey={industryKey}
                      key={industryKey}
                      count={arr.length}
                      index={index}
                      times={getIndustryTimes(industryKey, times)}
                      industryHoverHandler={IndustryHoverHandler}
                    />
                  )
              }
              {window.innerWidth > 1024
                ? <div className='marker_container'>
                  {
                    getTimeMarkers().map(year =>
                      <div className='year_marker' style={{ top: `${getYearPercent(year)}%` }} key={`marker_${year}`}><span className='year_label'>{year}</span></div>
                    )
                  }
                </div>
                : ''}
            </div>
          </VisibilitySensor>
        </div>
      </div>
    </Container>
  )
}

export default IndustryMatrix
